/**
 * PWA install prompt handler and SW update notifier.
 */
import { writable } from 'svelte/store';

export const canInstall = writable(false);
let deferredPrompt: any = null;

export function initPwaInstall() {
  window.addEventListener('beforeinstallprompt', (e: any) => {
    e.preventDefault();
    deferredPrompt = e;
    canInstall.set(true);
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    canInstall.set(false);
  });
}

export async function promptInstall() {
  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  try { await deferredPrompt.userChoice; } catch {}
  deferredPrompt = null;
  canInstall.set(false);
}

